import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import ShoppingCartItemsListItem from "./shoppingCartItemsListItem";
import {cartItemInterface} from "./cartItemInterface";
import AdvancedQuotingListItem from "./advancedQuoting/advancedQuotingListItem";


const ShoppingCartItemsBundledProducts = (props) => {

  const {parentCartItem, cartItems, fabricatorData, isMobile, isAdvancedMode, advancedModeProperties} = props;

  const fabricatorSettings = fabricatorData.settings;

  let bundledCartItems = cartItems.filter(cItem => cItem.bundleParentId === parentCartItem.id);

  if (fabricatorData.isAmericanStandard) {
    // the quoting tool needs to have the bundled products hidden (only for American standard) in the cart and receipt,
    // but still send items through the API to LP.
    // For American Standard on production, we need to unhide the side walls for the bundles on the checkout screen only
    // (Not the receipt). Only the sidewall bundle feature should display for American Standard.
    // All other Fabricators, the bundles features should be visible on both the checkout and receipt.
    bundledCartItems = bundledCartItems.filter(cItem => cItem.partId === "side_walls");
    if (!bundledCartItems.length) {
      return null;
    }
  }

  return (
    <div className="scart-block__bundled">
      <div className="scart-block__bundled-top">
        <FormattedMessage id="shoppingCart.bundledItems"/>
      </div>
      <ul className={"scart-block__list"
        + (fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost
        && !fabricatorData.hidePricesFromUser && !isMobile ? " scart-block__list--with-price" : "")}>
        {bundledCartItems.map(cartItem => {
          if (isAdvancedMode) {
            return <AdvancedQuotingListItem cartItem={cartItem}
                                            key={cartItem.id}
                                            {...advancedModeProperties}
                                            isBundleChild={true}/>
          }
          return <ShoppingCartItemsListItem cartItem={cartItem}
                                            key={cartItem.id}
                                            editFeatureGroupClick={() => null}
                                            isBundleChild={true}/>
        })}
      </ul>
    </div>
  )
};

ShoppingCartItemsBundledProducts.propTypes = {
  parentCartItem: PropTypes.shape(cartItemInterface).isRequired,
}

const mapStateToProps = (store) => {
  const {cartItems} = store.cartState;
  const {isMobile} = store.serverState;

  return {
    cartItems,
    fabricatorData: store.fabricatorState,
    isMobile,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCartItemsBundledProducts)

